// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mensagem {\n  white-space: pre-line;\n}", "",{"version":3,"sources":["webpack://./src/app/shared/components/staff-plan-prazo-dialog/staff-plan-prazo-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF","sourcesContent":[".mensagem {\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
